export default "__VITE_ASSET__CNxkVx1E__"